<div class="p-1">
    <mat-card class="p-0"> 
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2">
            <h2>Customers List</h2>  
            <button mat-raised-button color="primary" (click)="openCustomerDialog(null)">Add Customer</button>
        </div>
        <mat-divider></mat-divider>
        <div class="mat-table admin-table">
            <div class="mat-header-row">
                <div class="mat-header-cell">Full Name</div>
                <div class="mat-header-cell">Username</div> 
                <div class="mat-header-cell">Email</div>
                <div class="mat-header-cell">Store</div>
                <div class="mat-header-cell">Wallet Balance</div>
                <div class="mat-header-cell">Revenue</div>
                <div class="mat-header-cell"></div>
            </div>
            <div *ngFor="let customer of customers | paginate: { itemsPerPage: count, currentPage: page }" class="mat-row">
                <div class="mat-cell">{{customer.firstName}} {{customer.lastName}}</div>
                <div class="mat-cell">{{customer.username}}</div>
                <div class="mat-cell">{{customer.email}}</div>
                <div class="mat-cell">{{ ( stores | filterById : customer.storeId )?.name }}</div> 
                <div class="mat-cell">Rs.{{customer.walletBalance.toFixed(2)}}</div>
                <div class="mat-cell">Rs.{{customer.revenue.toFixed(2)}}</div>     
                <div class="mat-cell">
                    <div class="p-1 actions">          
                        <button mat-mini-fab color="primary" matTooltip="Edit" (click)="openCustomerDialog(customer)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-mini-fab color="warn" matTooltip="Delete" class="mx-1" (click)="remove(customer)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>      
            </div>
        </div>
    </mat-card>

    <div *ngIf="customers.length > 0" fxLayout="row wrap">
        <div fxFlex="100"> 
            <mat-card class="p-0 text-center">           
                <pagination-controls class="product-pagination" autoHide="true" maxSize="5" (pageChange)="onPageChanged($event)"></pagination-controls>
            </mat-card>
        </div>
    </div>
</div>